import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/examanet/examanet/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/examanet/examanet/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["BacArchivesClient"] */ "/home/runner/work/examanet/examanet/src/app/[locale]/bac/archives/client.tsx");
